import PropTypes from 'prop-types';

const notificationProptype = PropTypes.shape({
  status: PropTypes.string,
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
});

/**
 * @typedef {object} ShipmentStatusNotificationPropType
 * @property {string} status
 * @property {string|object} errorMessage
 */

export const ShipmentStatusGroupPropType = {
  labelPrintedStatus: PropTypes.shape({
    labelId: PropTypes.string,
    modifiedByGuid: PropTypes.string,
    modifiedDateTime: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    isPrinted: PropTypes.bool,
  }),
  labelCreatedDateTime: PropTypes.string,
  packingSlipPrintedStatus: PropTypes.shape({
    fulfillmentPlanId: PropTypes.string,
    modifiedByGuid: PropTypes.string,
    modifiedDateTime: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    isPrinted: PropTypes.bool,
  }),
  marketplaceNotification: notificationProptype,
  shipmentEmailNotification: notificationProptype,
  deliveryEmailNotification: notificationProptype,
  markPackingSlipPrinted: PropTypes.func,
  markLabelPrinted: PropTypes.func,
  returnEmailInformation: PropTypes.shape({
    status: PropTypes.oneOf(['sent', 'notsent']),
    errorMessage: PropTypes.string,
    sentDateTime: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  }),
  isThirdPartyFulfillment: PropTypes.bool,
};

/**
 * @typedef {object} ShipmentStatusGroupPropType
 * @property {object} labelPrintedStatus
 * @property {string} labelPrintedStatus.labelId
 * @property {string} labelPrintedStatus.modifiedByGuid
 * @property {Date|string} labelPrintedStatus.modifiedDateTime
 * @property {boolean} labelPrintedStatus.isPrinted
 * @property {string} labelCreatedDateTime
 * @property {object} packingSlipPrintedStatus
 * @property {string} packingSlipPrintedStatus.fulfillmentPlanId
 * @property {string} packingSlipPrintedStatus.modifiedByGuid
 * @property {Date|string} packingSlipPrintedStatus.modifiedDateTime
 * @property {boolean} packingSlipPrintedStatus.isPrinted
 * @property {ShipmentStatusNotificationPropType} marketplaceNotification
 * @property {ShipmentStatusNotificationPropType} shipmentEmailNotification
 * @property {ShipmentStatusNotificationPropType} deliveryEmailNotification
 * @property {Function} markPackingSlipPrinted
 * @property {Function} markLabelPrinted
 * @property {object} returnEmailInformation
 * @property {('sent'|'notsent')} returnEmailInformation.status
 * @property {string} returnEmailInformation.errorMessage
 * @property {Date|string} returnEmailInformation.sentDateTime
 * @property {boolean} isThirdPartyFulfillment
 */

export const ShipmentStatusPropType = PropTypes.shape({
  status: PropTypes.oneOf(['inProgress', 'shipped']),
  onHold: PropTypes.bool,
  packingSlipPrinted: PropTypes.object,
  labelCreated: PropTypes.object,
  labelPrinted: PropTypes.object,
  marketplaceNotified: PropTypes.object,
  shipmentEmailSent: PropTypes.object,
  deliveryEmailSent: PropTypes.object,
});

/**
 * @typedef {object} ShipmentStatusPropType
 * @property {('inProgress'|'shipped')} status
 * @property {boolean} onHold
 * @property {object} packingSlipPrinted
 * @property {object} labelCreated
 * @property {object} labelPrinted
 * @property {object} marketplaceNotified
 * @property {object} shipmentEmailSent
 * @property {object} deliveryEmailSent
 */
